import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "ortigueira",
        nomePrefeitura: "Prefeitura municipal de Ortigueira",
        logo: "ortigueira/logos/brasao.png",
        brasao: "ortigueira/logos/logo.png",
        municipio: "| ORTIGUEIRA - PR",
    },
    webgeo: {
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria municipal de ...",
        },
        consultaPrevia: {
            nomeSecretaria: "Divisão de Tributação",
            contact: {
                email: "xxx",
                endereco: "Av. Brasil, 694",
                horarioAtendimento: "xxx",
                telefone: "(43) 3461-8010",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-50.9250872, -24.2113218],
            zoom: 18,
        },
    },
    api: {
        url: "https://api-staging.semv.com.br/",
    },
    geoserver: {
        url: "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
